/* HD Header – Ankündigungsleiste, Ein-/Ausblenden beim Scrollen, Shop-Ausklappmenü,
   Such-Overlay mit Sofort-Ergebnissen, Vollbild-Menü am Handy, Warenkorb-Zähler-Animation */
(function () {
  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = window.requestAnimationFrame.bind(window);

  function init(root) {
    if (!root || root.__hdh) return;
    root.__hdh = true;
    var isHome = root.classList.contains('hdh--home');
    var scrim = document.querySelector('[data-hdh-scrim]');
    var search = document.querySelector('[data-hdh-search]');
    var drawer = document.querySelector('[data-hdh-drawer]');
    var state = { mega: false, search: false, drawer: false };
    var lastFocus = null;

    /* ---------- Höhe als CSS-Variable (Abstand unter dem festen Header) ---------- */
    function setH() { html.style.setProperty('--hdh-h', root.offsetHeight + 'px'); }
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(root);
    else window.addEventListener('resize', setH);

    function anyOpen() { return state.mega || state.search || state.drawer; }

    /* Solange Suche/Menü offen sind: Mausrad darf nur das Fenster selbst scrollen, nicht die Seite dahinter
       (das weiche Scrollen der Startseite ignoriert bereits abgefangene Ereignisse) */
    function canScroll(el, dy) {
      while (el && el !== document.body && el !== html) {
        var s = getComputedStyle(el);
        if (/(auto|scroll)/.test(s.overflowY) && el.scrollHeight > el.clientHeight + 1) {
          if (dy < 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight - 1) return true;
        }
        el = el.parentElement;
      }
      return false;
    }
    if (!window.__hdhWheel) {
      window.__hdhWheel = true;
      window.addEventListener('wheel', function (e) {
        if (!html.classList.contains('hdh-lock')) return;
        if (!canScroll(e.target, e.deltaY)) e.preventDefault();
      }, { passive: false, capture: true });
    }
    function lock() { html.classList.add('hdh-lock'); }
    function unlock() { if (!state.search && !state.drawer) html.classList.remove('hdh-lock'); }
    function later(el, ms, fn) { clearTimeout(el.__hdhT); el.__hdhT = setTimeout(fn, reduce ? 0 : ms); }

    /* ---------- Ankündigungsleiste: Botschaften wechseln ---------- */
    var bar = root.querySelector('[data-hdh-bar]');
    if (bar) {
      var msgs = [].slice.call(bar.querySelectorAll('.hdh__msg'));
      var idx = 0, paused = false, every = (Number(bar.getAttribute('data-interval')) || 5) * 1000;
      if (msgs.length > 1 && !reduce) {
        setInterval(function () {
          if (paused || document.hidden) return;
          var cur = msgs[idx]; idx = (idx + 1) % msgs.length; var nx = msgs[idx];
          cur.classList.remove('is-active'); cur.classList.add('is-out'); cur.setAttribute('aria-hidden', 'true');
          nx.classList.remove('is-out'); nx.classList.add('is-active'); nx.removeAttribute('aria-hidden');
          setTimeout(function () {
            cur.style.transition = 'none'; cur.classList.remove('is-out');
            void cur.offsetHeight; cur.style.transition = '';
          }, 750);
        }, every);
        bar.addEventListener('mouseenter', function () { paused = true; });
        bar.addEventListener('mouseleave', function () { paused = false; });
        bar.addEventListener('focusin', function () { paused = true; });
        bar.addEventListener('focusout', function () { paused = false; });
      }
    }

    /* ---------- Beim Runterscrollen ausblenden, beim Hochscrollen zeigen ---------- */
    var lastY = window.scrollY, acc = 0, ticking = false, hiddenNow = false;
    function show() { if (hiddenNow) { hiddenNow = false; root.classList.remove('is-hidden'); } }
    function hide() { if (!hiddenNow) { hiddenNow = true; root.classList.add('is-hidden'); } }
    function onScroll() {
      ticking = false;
      var y = Math.max(0, window.scrollY), dy = y - lastY; lastY = y;
      if (isHome) root.classList.toggle('is-top', y < 12);
      if (anyOpen()) {
        if (state.mega && Math.abs(y - megaY) > 60) closeMega();
        return;
      }
      if (html.classList.contains('hd-hero-lock') || y < root.offsetHeight + 24) { acc = 0; show(); return; }
      if ((dy > 0 && acc < 0) || (dy < 0 && acc > 0)) acc = 0;
      acc += dy;
      if (acc > 48) hide();
      else if (acc < -36) show();
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; raf(onScroll); } }, { passive: true });
    onScroll();
    root.addEventListener('focusin', show);

    /* ---------- Großes Shop-Ausklappmenü ---------- */
    var trigger = root.querySelector('[data-hdh-mega-trigger]');
    var mega = root.querySelector('[data-hdh-mega]');
    var megaY = 0, openT = 0, closeT = 0, lastPointer = 'mouse';
    function openMega(focusFirst) {
      clearTimeout(closeT);
      if (!mega || state.mega) return;
      state.mega = true; megaY = window.scrollY; show();
      mega.hidden = false; if (scrim) scrim.hidden = false;
      root.classList.add('is-mega');
      trigger.setAttribute('aria-expanded', 'true');
      void mega.offsetWidth; /* Startzustand festschreiben, dann Übergang starten */
      mega.classList.add('is-open'); if (scrim) scrim.classList.add('is-open');
      if (focusFirst) { var f = mega.querySelector('a'); if (f) f.focus({ preventScroll: true }); }
    }
    function closeMega() {
      clearTimeout(openT);
      if (!mega || !state.mega) return;
      state.mega = false;
      mega.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-open');
      root.classList.remove('is-mega');
      trigger.setAttribute('aria-expanded', 'false');
      later(mega, 600, function () { if (!state.mega) { mega.hidden = true; if (scrim && !state.mega) scrim.hidden = true; } });
    }
    if (trigger && mega) {
      var hoverable = window.matchMedia('(hover: hover)');
      trigger.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType; });
      trigger.addEventListener('mouseenter', function () {
        if (!hoverable.matches) return;
        clearTimeout(closeT); openT = setTimeout(openMega, 90);
      });
      [trigger, mega].forEach(function (el) {
        el.addEventListener('mouseleave', function () {
          if (!hoverable.matches) return;
          clearTimeout(openT); closeT = setTimeout(closeMega, 240);
        });
        el.addEventListener('mouseenter', function () { if (state.mega) clearTimeout(closeT); });
      });
      trigger.addEventListener('click', function (e) {
        /* Touch oder noch geschlossen: erst öffnen statt sofort wegzuspringen */
        if (!state.mega || lastPointer === 'touch') {
          if (state.mega) { e.preventDefault(); closeMega(); return; }
          e.preventDefault(); openMega(false);
        }
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || ((e.key === 'Enter' || e.key === ' ') && !state.mega)) {
          e.preventDefault(); openMega(true);
        }
      });
      root.querySelectorAll('.hdh__nav-link:not([data-hdh-mega-trigger])').forEach(function (a) {
        a.addEventListener('mouseenter', function () { if (state.mega) closeMega(); });
      });
      mega.addEventListener('focusout', function (e) {
        if (!mega.contains(e.relatedTarget) && e.relatedTarget !== trigger) closeMega();
      });
    }
    if (scrim) scrim.addEventListener('click', function () { closeMega(); });

    /* ---------- Fokus im offenen Fenster halten ---------- */
    function trap(box, e) {
      if (e.key !== 'Tab') return;
      var f = [].slice.call(box.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ---------- Vollbild-Menü (Handy/Tablet) ---------- */
    var burger = root.querySelector('[data-hdh-open-drawer]');
    function openDrawer() {
      if (!drawer || state.drawer) return;
      lastFocus = document.activeElement;
      state.drawer = true; lock();
      drawer.hidden = false;
      if (burger) burger.setAttribute('aria-expanded', 'true');
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      var c = drawer.querySelector('[data-hdh-close-drawer]'); if (c) c.focus({ preventScroll: true });
    }
    function closeDrawer(keepLock) {
      if (!drawer || !state.drawer) return;
      state.drawer = false;
      drawer.classList.remove('is-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      later(drawer, 450, function () { if (!state.drawer) drawer.hidden = true; });
      if (!keepLock) { unlock(); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
    }
    if (burger) burger.addEventListener('click', openDrawer);
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-hdh-close-drawer]')) closeDrawer();
        else if (e.target.closest('[data-hdh-drawer-search]')) { closeDrawer(true); openSearch(); }
      });
      drawer.addEventListener('keydown', function (e) { trap(drawer, e); });
    }
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) closeDrawer(); else closeMega(); });

    /* ---------- Such-Overlay mit Sofort-Ergebnissen ---------- */
    var input = search && search.querySelector('[data-hdh-search-input]');
    var results = search && search.querySelector('[data-hdh-search-results]');
    var start = search && search.querySelector('[data-hdh-search-start]');
    var searchBtns = root.querySelectorAll('[data-hdh-open-search]');
    var ctrl = null, timer = 0, lastQ = '';
    function openSearch() {
      if (!search || state.search) return;
      if (!state.drawer) lastFocus = document.activeElement;
      closeMega();
      state.search = true; lock(); show();
      search.hidden = false;
      searchBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      void search.offsetWidth;
      search.classList.add('is-open'); input.focus({ preventScroll: true });
    }
    function closeSearch() {
      if (!search || !state.search) return;
      state.search = false;
      search.classList.remove('is-open');
      searchBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      later(search, 400, function () { if (!state.search) search.hidden = true; });
      unlock();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    searchBtns.forEach(function (b) { b.addEventListener('click', openSearch); });
    if (search) {
      search.addEventListener('click', function (e) {
        if (e.target === search || e.target.closest('[data-hdh-close-search]')) closeSearch();
        var s = e.target.closest('[data-hdh-suggest]');
        if (s) { e.preventDefault(); input.value = s.getAttribute('data-hdh-suggest'); input.focus(); run(); }
      });
      search.addEventListener('keydown', function (e) {
        trap(search, e);
        if (e.key === 'ArrowDown' && document.activeElement === input) {
          var first = results.querySelector('a'); if (first) { e.preventDefault(); first.focus(); }
        }
      });
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 160); });
    }

    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var fmt;
    try { fmt = new Intl.NumberFormat(html.lang || 'de-DE', { style: 'currency', currency: cur }); } catch (e) { fmt = null; }
    function money(v) {
      var n = Number(v); if (isNaN(n)) return '';
      if (Number.isInteger(n) && String(v).indexOf('.') === -1 && n > 999) n = n / 100; /* Cent-Angaben */
      return fmt ? fmt.format(n) : n.toFixed(2).replace('.', ',') + ' €';
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function mark(t, q) {
      var e = esc(t), words = q.trim().split(/\s+/).filter(Boolean).map(function (w) { return esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      if (!words.length) return e;
      return e.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>');
    }
    function sized(u, w) {
      if (!u) return '';
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function allLink(q) {
      var base = (window.routes && window.routes.search_url) || '/search';
      return '<a class="hdh-search__all" href="' + base + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">Alle Ergebnisse für „' + esc(q) + '“<svg aria-hidden="true"><use href="#hdh-i-arrow"/></svg></a>';
    }
    function run() {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      if (ctrl) ctrl.abort();
      if (!q) { results.innerHTML = ''; start.hidden = false; return; }
      start.hidden = true;
      if (!results.innerHTML) results.innerHTML = '<div class="hdh-search__loading"></div>';
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      var url = base + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (q !== input.value.trim()) return;
          var res = (data && data.resources && data.resources.results) || {};
          var prods = res.products || [], cols = res.collections || [];
          var out = '';
          if (!prods.length && !cols.length) {
            out = '<p class="hdh-search__empty">Nichts gefunden für „' + esc(q) + '“. Probier einen anderen Begriff.</p>';
            results.innerHTML = out; start.hidden = false; return;
          }
          if (prods.length) {
            out += '<div class="hdh-search__group"><p class="hdh__eyebrow">Produkte</p><ul class="hdh-search__grid" role="list">';
            prods.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              var from = p.price_min && p.price_max && p.price_min !== p.price_max ? 'ab ' : '';
              var was = Number(p.compare_at_price_min) > Number(p.price_min) ? '<s>' + money(p.compare_at_price_min) + '</s> ' : '';
              out += '<li><a class="hdh-search__item" href="' + esc(p.url) + '">' +
                '<span class="hdh-search__thumb">' + (img ? '<img src="' + esc(sized(img, 160)) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</span>' +
                '<span><span class="hdh-search__name">' + mark(p.title, q) + '</span>' +
                '<span class="hdh-search__price">' + was + from + money(p.price_min || p.price) + (p.available === false ? ' · ausverkauft' : '') + '</span></span></a></li>';
            });
            out += '</ul></div>';
          }
          if (cols.length) {
            out += '<div class="hdh-search__group"><p class="hdh__eyebrow">Kollektionen</p><ul class="hdh-search__chips" role="list">';
            cols.forEach(function (c) { out += '<li><a class="hdh__pill" href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; });
            out += '</ul></div>';
          }
          out += allLink(q);
          results.innerHTML = out;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          results.innerHTML = allLink(q);
        });
    }

    /* ---------- Escape schließt alles ---------- */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (state.search) closeSearch();
      else if (state.drawer) closeDrawer();
      else if (state.mega) { closeMega(); if (trigger) trigger.focus(); }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { closeSearch(); closeDrawer(); closeMega(); } });

    /* ---------- Warenkorb-Zähler: kleine Animation, wenn sich etwas ändert ---------- */
    var bubble = document.getElementById('cart-icon-bubble');
    var cartLink = root.querySelector('.hdh__icon--cart');
    if (bubble && 'MutationObserver' in window) {
      new MutationObserver(function () {
        show();
        if (reduce) return;
        [bubble, cartLink].forEach(function (el) { if (!el) return; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
        setTimeout(function () { bubble.classList.remove('is-bump'); if (cartLink) cartLink.classList.remove('is-bump'); }, 950);
      }).observe(bubble, { childList: true, subtree: true, characterData: true });
    }

    /* Für andere Skripte (z. B. späterer Warenkorb) */
    root.hdh = { show: show, hide: hide, openSearch: openSearch, closeSearch: closeSearch, openDrawer: openDrawer, closeDrawer: closeDrawer };
  }

  function boot() { init(document.querySelector('[data-hdh]')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-hdh]')) { html.classList.remove('hdh-lock'); boot(); }
  });
})();
